
export interface PasswordValidationResult {
  strength: number; // 0-4 scale
  feedback: string[];
}

export function validatePassword(password: string): PasswordValidationResult {
  const result: PasswordValidationResult = {
    strength: 0,
    feedback: []
  };
  
  // Empty password
  if (!password) {
    result.feedback.push('Password is required');
    return result;
  }
  
  // Initial strength based on length
  if (password.length < 8) {
    result.strength = 1;
    result.feedback.push('Use at least 8 characters');
  } else {
    result.strength = 2;
  }
  
  // Check for requirements
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
  
  // Add feedback based on missing criteria
  if (!hasUppercase) {
    result.feedback.push('Add an uppercase letter');
  }
  
  if (!hasLowercase) {
    result.feedback.push('Add a lowercase letter');
  }
  
  if (!hasNumbers) {
    result.feedback.push('Add a number');
  }
  
  if (!hasSpecialChars) {
    result.feedback.push('Add a special character (!@#$%^&*...)');
  }
  
  // Adjust strength based on complexity
  let complexityCount = 0;
  if (hasUppercase) complexityCount++;
  if (hasLowercase) complexityCount++;
  if (hasNumbers) complexityCount++;
  if (hasSpecialChars) complexityCount++;
  
  // Boost strength for meeting criteria
  if (password.length >= 8) {
    if (complexityCount >= 3) {
      result.strength = 3; // Good
    }
    
    if (complexityCount === 4 && password.length >= 10) {
      result.strength = 4; // Strong
    }
  }
  
  // If strength is good but still has feedback, add a positive note
  if (result.strength >= 3 && result.feedback.length > 0) {
    result.feedback.unshift('Password is good, but can be stronger');
  }
  
  // For strong passwords with empty feedback, add positive feedback
  if (result.strength === 4 && result.feedback.length === 0) {
    result.feedback.push('Excellent password!');
  }
  
  return result;
}
